// extracted by mini-css-extract-plugin
export default {"root":"_2a8hJZd5","content":"Ao6Pu9Md","description":"_2zbH1AUp","heading":"_1w8D4sYD","footer":"_79buttuJ","badge":"_2kTAGV6a"};